import { AdminPermissions } from '@user1st/api-client';
import { t } from 'i18next';
import { FormModal } from '@/shared/components/Modals/GeneralModals/FormModal';
import { DeleteModal } from '@/shared/components/Modals/GeneralModals/DeleteModal';
import { trustedSourceTypeTitles } from '@/stores/TrustedSourceStore/TrustedSourceStore.consts';
import { TrustedSourceForm } from '@/shared/components/Forms/TrustedSourceForms/TrustedSourceForm';
import { ActionsProps as UserActionsProps } from '@/Views/AfterLogin/Main/SearchPanel/Actions/UserActions.consts';
import { TrustedSourceDto } from '@user1st/api-client';

export type ActionsDropdownProps = UserActionsProps & {
  item: TrustedSourceDto;
};

export type ActionsProps = {
  item: TrustedSourceDto;
  getItems: () => void;
};

export const getActions = ({ item, getItems }: ActionsProps) => [
  {
    permission: AdminPermissions.UpdateTrustedSource,
    component: (
      <FormModal
        key="trusted-source"
        action="edit"
        btnText={t('admin.actions.edit')}
        form={<TrustedSourceForm formName={`edit-form-${item.id}`} selected={item} />}
      />
    ),
  },
  {
    permission: AdminPermissions.DeleteTrustedSource,
    component: (
      <DeleteModal
        resource="trusted-source"
        id={item.id}
        label={`${trustedSourceTypeTitles[item.type]}: ${item.value}`}
        refetchItems={getItems}
      />
    ),
  },
];
